function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6666 10.3334V27.6667M19 16.8334V27.6667M10.3333 23.3334V27.6667M5.99996 36.3334H32C34.3932 36.3334 36.3333 34.3933 36.3333 32.0001V6.00008C36.3333 3.60685 34.3932 1.66675 32 1.66675H5.99996C3.60673 1.66675 1.66663 3.60685 1.66663 6.00008V32.0001C1.66663 34.3933 3.60673 36.3334 5.99996 36.3334Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.27f820ee.svg";
export { ForwardRef as ReactComponent };